import Swiper from "swiper/bundle";

export function idxFunc() {
  const swiper = new Swiper('.swiper', {
    speed: 1000,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev'
    // },
    slidesPerView: 'auto',
    spaceBetween: 10,  
    breakpoints: {
      768: {
        spaceBetween: 15,  
      }
    }
  });

  // すべての検索フィールドを取得
  var searchInputs = document.querySelectorAll('.search-field');

  searchInputs.forEach(function(searchInput) {
    var searchButton = searchInput.closest('.search-form').querySelector('.searchsubmit');
  
    // 各検索フィールドに対してイベントリスナーを設定
    searchInput.addEventListener('input', function() {
      if (this.value.trim().length > 0) {
        searchButton.removeAttribute('disabled');
      } else {
        searchButton.setAttribute('disabled', 'disabled');
      }
    });
  });  

  var pagetop = document.querySelector('.pagetop'); // ページトップボタンを選択
  var offset = 100; // ボタンが表示されるスクロール量（ピクセル）
  
  window.addEventListener('scroll', function() {
    if (window.pageYOffset > offset) {
      pagetop.style.opacity = '1';
      pagetop.style.visibility = 'visible';
    } else {
      pagetop.style.opacity = '0';
      pagetop.style.visibility = 'hidden';
    }
  });
}
